import React, { createRef, PureComponent } from 'react';
import Slider, { Settings } from 'react-slick';
import { withSizes } from 'react-sizes';
import b from 'b_';

import './entities-carousel.css';

import { mapSizesToProps } from 'client/helpers/sizes';

export interface ComponentProps {
    settings?: Settings;
}

export interface SizeProps {
    isDesktop: boolean;
}

export interface State {
    initiated: boolean;
}

type Props = ComponentProps & SizeProps;

const defaultSettings: Settings = {
    speed: 500,
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    accessibility: false,
    focusOnSelect: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 700,
            settings: {
                slidesToShow: 1
            }
        }
    ]
};

const class_ = b.with('entities-carousel');

class EntitiesCarousel extends PureComponent<Props, State> {
    public wrapper: any = createRef();

    public state = {
        initiated: false
    };

    public onInit = () => {
        this.setState({ initiated: true });
    };

    public componentDidMount() {
        const links = this.wrapper.current.querySelectorAll('a');

        [].forEach.call(links, (link: any) => {
            link.addEventListener('click', (event: MouseEvent) => event.stopPropagation());
        });
    }

    public render() {
        const { initiated } = this.state;
        const { settings = {}, children } = this.props;
        const sliderSettings = { ...defaultSettings, ...settings };

        return (
            <div className={class_({ initiated })} ref={this.wrapper}>
                <Slider
                    {...sliderSettings}
                    onInit={this.onInit}
                >
                    {children}
                </Slider>
            </div>
        );
    }
}

export default withSizes(mapSizesToProps)(EntitiesCarousel);
